import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import { call, put, takeLatest } from "redux-saga/effects";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { SurveyAnswerDetail } from "../types";
import {
	getListSurveyAnswerAsync,
	GetListSurveyAnswerPayload,
	setListSurveyAnswer,
	setTotalSurvey,
} from "./survey-answer.slice";

function* getListSurveyAnswerSaga(action: PayloadAction<GetListSurveyAnswerPayload>) {
	yield put({ type: setListSurveyAnswer.type, payload: { data: [] } });
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<SurveyAnswerDetail[]>>(
				"/dashboard/answer-survey",
				{
					...query,
					skip: query.skip * query.take,
				},
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setListSurveyAnswer.type, payload: response });
		yield put({ type: setTotalSurvey.type, payload: response });
		callback && callback();
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetListSurveyAnswer() {
	yield takeLatest(getListSurveyAnswerAsync, getListSurveyAnswerSaga);
}

const surveySaga = [watchGetListSurveyAnswer()];

export default surveySaga;
